"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ModalHeaderWithTitleAndClose = function ModalHeaderWithTitleAndClose(_ref) {
  var title = _ref.title,
    close = _ref.close,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles;
  return _react["default"].createElement(_ModalHeader["default"], {
    styles: styles
  }, _react["default"].createElement("h3", null, title), _react["default"].createElement("button", {
    type: "button",
    className: "close",
    onClick: close
  }, _react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")));
};
ModalHeaderWithTitleAndClose.propTypes = {
  /** title of the modal header */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  /** callback when close is clicked */
  close: _propTypes["default"].func.isRequired,
  /** overrideable styles */
  styles: _propTypes["default"].shape({
    backgroundColor: _propTypes["default"].string,
    bottomBorderColor: _propTypes["default"].string,
    color: _propTypes["default"].string
  })
};
ModalHeaderWithTitleAndClose.displayName = "WithTitleAndClose";
ModalHeaderWithTitleAndClose.defaultProps = {
  styles: {}
};
var _default = ModalHeaderWithTitleAndClose;
exports["default"] = _default;